import { gql } from '@apollo/client'

const DISCOUNT_RULE_FIELDS = gql`
  fragment DiscountRuleFieldsMut on DiscountRule {
    id
    name
    active
    discount_class
    effect_type
    effect_value
    multi_buy_qty
    scope_type
    scope_value_json
    allocation
    trigger_type
    min_staff_role
    priority
    conditions {
      type
      value_json
    }
    limit {
      max_uses_total
      max_per_order
      starts_at
      ends_at
    }
    codes {
      id
      code
      description
      active
      max_uses
      expires_at
    }
  }
`

export const CREATE_DISCOUNT_RULE = gql`
  ${DISCOUNT_RULE_FIELDS}
  mutation CreateDiscountRule($input: CreateDiscountRuleInput!) {
    createDiscountRule(input: $input) {
      ...DiscountRuleFieldsMut
    }
  }
`

export const UPDATE_DISCOUNT_RULE = gql`
  ${DISCOUNT_RULE_FIELDS}
  mutation UpdateDiscountRule($id: Int!, $input: UpdateDiscountRuleInput!) {
    updateDiscountRule(id: $id, input: $input) {
      ...DiscountRuleFieldsMut
    }
  }
`

export const DEACTIVATE_DISCOUNT_RULE = gql`
  mutation DeactivateDiscountRule($id: Int!) {
    deactivateDiscountRule(id: $id) {
      id
      name
      active
    }
  }
`

export const ADD_DISCOUNT_CODE = gql`
  mutation AddDiscountCode($rule_id: Int!, $code: String!, $description: String, $max_uses: Int, $expires_at: String) {
    addDiscountCode(rule_id: $rule_id, code: $code, description: $description, max_uses: $max_uses, expires_at: $expires_at) {
      id
      code
      description
      active
      max_uses
      expires_at
      created_at
    }
  }
`

export const UPDATE_DISCOUNT_CODE = gql`
  mutation UpdateDiscountCode($id: Int!, $description: String, $max_uses: Int, $expires_at: String, $active: Boolean) {
    updateDiscountCode(id: $id, description: $description, max_uses: $max_uses, expires_at: $expires_at, active: $active) {
      id
      code
      description
      active
      max_uses
      expires_at
      created_at
    }
  }
`

export const DEACTIVATE_DISCOUNT_CODE = gql`
  mutation DeactivateDiscountCode($id: Int!) {
    deactivateDiscountCode(id: $id) {
      id
      code
      active
    }
  }
`
